import Container from "~/lib/components/layout/Container";
import React from "react";
import { useTranslation } from "~/lib/utils/store/useTranslation";

const LoadingContainer = () => {
  const { t } = useTranslation();
  return (
    <Container className="flex justify-center items-center min-h-screen">
      {t("loading")}
    </Container>
  );
};

export default LoadingContainer;
